/* Minnak Theme – theme.js */
(function () {
  'use strict';
  var T = window.theme || {};
  var ROOT = (T.routes && T.routes.root) || '/';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} TL';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Cart ---------- */
  function updateCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('.cart-icon').forEach(function (el) {
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
        return cart;
      });
  }
  var toastTimer;
  function showToast(text, isError) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.querySelector('[data-toast-text]').textContent = text;
    var link = t.querySelector('.toast__link'); if (link) link.hidden = !!isError;
    t.hidden = false; clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3500);
  }
  function addFormToCart(form) {
    var fd = new FormData(form);
    // inputs associated via form="" attribute are included by FormData automatically
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || T.strings.error);
          return data;
        });
      });
  }


  /* ---------- Yan sepet (cart drawer) ---------- */
  var Drawer = (function () {
    var el = document.querySelector('[data-cart-drawer]');
    if (!el) return null;
    var body = el.querySelector('[data-drawer-body]');
    var foot = el.querySelector('[data-drawer-foot]');
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function img(url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
    function render(cart) {
      var cnt = el.querySelector('[data-drawer-count]'); if (cnt) cnt.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      var ship = el.querySelector('[data-drawer-ship]');
      if (ship) {
        var th = parseInt(ship.dataset.threshold, 10) || 0;
        var rem = th - cart.total_price;
        ship.querySelector('[data-drawer-ship-text]').innerHTML = cart.item_count === 0 ? '' : (rem > 0 ? 'Ücretsiz kargo için <strong>' + formatMoney(rem) + '</strong> daha ekle' : '🎉 <strong>Ücretsiz kargo</strong> kazandın!');
        ship.querySelector('[data-drawer-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price * 100 / (th || 1))) + '%';
        ship.hidden = cart.item_count === 0;
      }
      if (!cart.item_count) {
        body.innerHTML = '<div class="drawer__empty"><p>Sepetin şu an boş.</p><a href="' + ROOT + 'collections/all" class="btn btn--primary">Alışverişe başla</a></div>';
        foot.hidden = true; return;
      }
      body.innerHTML = '<ul class="drawer__items">' + cart.items.map(function (it, i) {
        var props = '';
        if (it.properties) Object.keys(it.properties).forEach(function (k) {
          var v = it.properties[k]; if (!v || k.charAt(0) === '_') return;
          props += '<span class="drawer__prop">' + esc(k) + ': ' + esc(v) + '</span>';
        });
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="drawer__variant">' + esc(it.variant_title) + '</span>' : '';
        var old = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        return '<li class="drawer__item" data-line="' + (i + 1) + '">' +
          '<a href="' + esc(it.url) + '" class="drawer__img">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="drawer__info"><a href="' + esc(it.url) + '" class="drawer__title">' + esc(it.product_title) + '</a>' + variant + props +
          '<div class="drawer__row"><div class="qty qty--small"><button type="button" class="qty__btn" data-drawer-qty="-1" aria-label="Azalt">−</button><span class="qty__input">' + it.quantity + '</span><button type="button" class="qty__btn" data-drawer-qty="1" aria-label="Artır">+</button></div>' +
          '<button type="button" class="drawer__remove" data-drawer-remove>Kaldır</button></div></div>' +
          '<div class="drawer__price">' + old + '<strong>' + formatMoney(it.final_line_price) + '</strong></div></li>';
      }).join('') + '</ul>';
      el.querySelector('[data-drawer-total]').textContent = formatMoney(cart.total_price);
      foot.hidden = false;
    }
    function load() {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
    }
    function change(line, qty) {
      el.classList.add('is-busy');
      return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render).finally(function () { el.classList.remove('is-busy'); });
    }
    function open() {
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('drawer-lock');
      return load();
    }
    function close() { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('drawer-lock'); }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { close(); return; }
      var li = e.target.closest('[data-line]'); if (!li) return;
      var line = parseInt(li.dataset.line, 10);
      var q = parseInt(li.querySelector('.qty__input').textContent, 10);
      var b = e.target.closest('[data-drawer-qty]');
      if (b) { change(line, Math.max(0, q + parseInt(b.dataset.drawerQty, 10))); return; }
      if (e.target.closest('[data-drawer-remove]')) change(line, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.cart-icon');
      if (a) { e.preventDefault(); open(); }
    });
    return { open: open, close: close, load: load };
  })();

  function afterAdd() {
    if (T.cartType === 'page') { window.location.href = ROOT + 'cart'; return; }
    if (T.cartType === 'drawer' && Drawer) { Drawer.open(); return; }
    updateCartCount().then(function () { showToast(T.strings.added); });
  }

  /* ---------- Qty steppers (cart + product) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '1', 10);
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) {
      clearTimeout(e.target._t);
      var form = e.target.form;
      e.target._t = setTimeout(function () { form.submit(); }, 450);
    }
  });

  /* ---------- Product section ---------- */
  function ProductSection(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var buyNow = form.querySelector('[data-buy-now]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var bundleInputs = root.querySelectorAll('[data-bundle]');
    var colorsEl = root.querySelector('[data-colors]');
    var units = 1;

    function variantById(id) { return product.variants.find(function (v) { return String(v.id) === String(id); }); }

    /* Price + buttons */
    function render(variant) {
      if (!variant) {
        addBtn.disabled = true; if (buyNow) buyNow.disabled = true;
        if (addLabel) addLabel.textContent = T.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      if (buyNow) buyNow.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      root.querySelectorAll('[data-price-wrapper]').forEach(function (pw) {
        pw.querySelector('[data-price]').textContent = formatMoney(variant.price);
        pw.classList.toggle('price--sale', !!onSale);
        var cmp = pw.querySelector('[data-compare-price]');
        if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(variant.compare_at_price); }
        var badge = pw.querySelector('[data-sale-badge]');
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.querySelector('[data-saving]').textContent = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        }
      });
      var up = root.querySelector('[data-unit-price]');
      if (up) up.textContent = units > 1 ? 'Adet başı ' + formatMoney(Math.round(variant.price / units)) : '';
      var sp = root.querySelector('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(variant.price);
      var sc = root.querySelector('[data-sticky-compare]');
      if (sc) { sc.hidden = !onSale; if (onSale) sc.textContent = formatMoney(variant.compare_at_price); }
      var sb = root.querySelector('[data-sticky-btn]'); if (sb) sb.disabled = !variant.available;
      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Classic option pickers */
    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function markAvailability() {
      var sel = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          if (input.nextElementSibling) input.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    if (fieldsets.length) {
      markAvailability();
      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-option-index]')) return;
        var sel = selectedOptions();
        fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-option-value]'); if (l) l.textContent = sel[i]; });
        var v = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        markAvailability(); render(v);
        if (v && v.featured_media) gallery && gallery.goToMedia(v.featured_media.id);
      });
    }

    /* Bundles */
    function currentBundle() {
      for (var i = 0; i < bundleInputs.length; i++) if (bundleInputs[i].checked) return bundleInputs[i];
      return null;
    }
    if (bundleInputs.length) {
      if (!currentBundle()) { var firstOk = Array.prototype.find.call(bundleInputs, function (b) { return !b.disabled; }); if (firstOk) firstOk.checked = true; }
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-bundle]')) return;
        applyBundle();
      });
    }
    function applyBundle() {
      var b = currentBundle();
      if (!b) return;
      units = parseInt(b.dataset.units || '1', 10) || 1;
      var st = root.querySelector('[data-sticky-title]');
      if (st) st.textContent = b.dataset.title;
      render(variantById(b.value));
      colors.setUnits(units);
    }

    /* Colors */
    var colors = (function () {
      var api = { setUnits: function () {} };
      if (!colorsEl) return api;
      var chips = colorsEl.querySelectorAll('[data-color-chip]');
      var chipWrap = colorsEl.querySelector('[data-color-chips]');
      var counterWrap = colorsEl.querySelector('[data-color-counters]');
      var rows = colorsEl.querySelectorAll('[data-color-row]');
      var input = colorsEl.querySelector('[data-color-input]');
      var summary = colorsEl.querySelector('[data-color-summary]');
      var names = Array.prototype.map.call(chips, function (c) { return c.dataset.colorChip; });
      var counts = names.map(function () { return 0; });
      var single = 0;
      var total = 1;

      function write() {
        var val;
        if (total === 1) {
          val = names[single];
          chips.forEach(function (c, i) { c.classList.toggle('is-active', i === single); c.setAttribute('aria-pressed', i === single); });
        } else {
          rows.forEach(function (r, i) { r.querySelector('[data-color-count]').textContent = counts[i]; });
          val = names.map(function (n, i) { return counts[i] ? counts[i] + ' ' + n : null; }).filter(Boolean).join(' + ');
        }
        input.value = val;
        if (summary) summary.textContent = val;
      }
      function distribute(n) {
        counts = names.map(function () { return 0; });
        for (var k = 0; k < n; k++) counts[k % names.length]++;
      }
      api.setUnits = function (n) {
        total = n;
        chipWrap.hidden = n > 1;
        counterWrap.hidden = n <= 1;
        if (n > 1) distribute(n);
        write();
      };
      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () {
          single = i; write();
          if (chip.dataset.colorImage && gallery) gallery.showColor(names[i], chip.dataset.colorImage);
        });
      });
      rows.forEach(function (row, i) {
        row.querySelector('[data-color-plus]').addEventListener('click', function () {
          if (counts[i] >= total) return;
          // take one from another color that has some
          for (var j = counts.length - 1; j >= 0; j--) { if (j !== i && counts[j] > 0) { counts[j]--; counts[i]++; break; } }
          write();
        });
        row.querySelector('[data-color-minus]').addEventListener('click', function () {
          if (counts[i] <= 0) return;
          var j = (i + 1) % counts.length; counts[i]--; counts[j]++;
          write();
        });
      });
      return api;
    })();

    /* Gallery */
    var gallery = (function () {
      var g = root.querySelector('[data-gallery]');
      if (!g) return null;
      var track = g.querySelector('[data-gallery-track]');
      var slides = g.querySelectorAll('[data-slide]');
      var thumbs = g.querySelectorAll('[data-thumb]');
      function go(i) {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }
      function setActive(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
      function index() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { setActive(index()); }, 80); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); }); });
      var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(Math.max(0, index() - 1)); });
      if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, index() + 1)); });
      return {
        goToMedia: function (id) {
          Array.prototype.forEach.call(slides, function (s, i) { if (s.dataset.mediaId === String(id)) go(i); });
        },
        showColor: function (name, src) {
          var key = (name || '').toLowerCase();
          for (var i = 0; i < slides.length; i++) {
            var alt = slides[i].dataset.alt || '';
            if (alt && (alt.indexOf(key) > -1 || (src && src.indexOf(alt) > -1))) { go(i); return; }
          }
          var img = slides[0] && slides[0].querySelector('img');
          if (img && src) { img.removeAttribute('srcset'); img.src = src; go(0); }
        }
      };
    })();

    /* Submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      addFormToCart(form)
        .then(afterAdd)
        .catch(function (err) { showToast(err.message || T.strings.error, true); })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        buyNow.classList.add('is-loading');
        addFormToCart(form)
          .then(function () { window.location.href = ROOT + 'checkout'; })
          .catch(function (err) { showToast(err.message || T.strings.error, true); buyNow.classList.remove('is-loading'); });
      });
    }

    /* Init */
    if (bundleInputs.length) applyBundle();
    else { colors.setUnits(1); }

    /* Sticky ATC */
    var bar = root.querySelector('[data-sticky-atc]');
    var target = root.querySelector('[data-main-buy]');
    if (bar && target && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.footer');
      var buyVisible = true, footerVisible = false;
      var toggle = function () {
        var show = !buyVisible && !footerVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = bar.querySelector('button'); if (b) b.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; toggle(); }).observe(target);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; toggle(); }).observe(footer);
    }
  }

  /* ---------- Delivery estimate ---------- */
  var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function addBusinessDays(date, n, sat) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day === 0 || (day === 6 && !sat)) continue;
      n--;
    }
    return d;
  }
  function initDelivery(el) {
    var min = parseInt(el.dataset.min, 10) || 2, max = parseInt(el.dataset.max, 10) || 5;
    var sat = el.dataset.saturday === 'true';
    var now = new Date();
    var a = addBusinessDays(now, min, sat), b = addBusinessDays(now, max, sat);
    var txt = a.getMonth() === b.getMonth()
      ? a.getDate() + ' - ' + b.getDate() + ' ' + MONTHS[b.getMonth()]
      : a.getDate() + ' ' + MONTHS[a.getMonth()] + ' - ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    var r = el.querySelector('[data-delivery-range]'); if (r) r.textContent = txt;
    var cutoff = parseInt(el.dataset.cutoff, 10) || 0;
    var box = el.querySelector('[data-delivery-cutoff]'), timer = el.querySelector('[data-delivery-timer]');
    if (cutoff > 0 && box && timer) {
      var tick = function () {
        var n = new Date(), end = new Date(n); end.setHours(cutoff, 0, 0, 0);
        var day = n.getDay();
        var diff = end - n;
        if (diff <= 0 || day === 0 || (day === 6 && !sat)) { box.hidden = true; return; }
        box.hidden = false;
        var h = Math.floor(diff / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
        timer.textContent = [h, m, s].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
      };
      tick(); setInterval(tick, 1000);
    }
  }

  /* ---------- Before / after ---------- */
  function initBA(el) {
    var range = el.querySelector('[data-ba-range]');
    if (!range) return;
    range.addEventListener('input', function () { el.style.setProperty('--pos', range.value + '%'); });
  }

  /* ---------- Reviews load more ---------- */
  function initReviews(grid) {
    var n = parseInt(grid.dataset.show, 10) || 6;
    var items = grid.querySelectorAll('.review');
    var btn = grid.parentElement.querySelector('[data-reviews-more]');
    if (items.length <= n || !btn) return;
    items.forEach(function (it, i) { if (i >= n) it.classList.add('is-hidden'); });
    btn.hidden = false;
    btn.addEventListener('click', function () {
      grid.querySelectorAll('.review.is-hidden').forEach(function (it) { it.classList.remove('is-hidden'); });
      btn.hidden = true;
    });
  }

  /* ---------- Lightbox (yorum fotoğrafları) ---------- */
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('[data-lightbox]');
    if (trg) {
      var sec = trg.closest('section') || document;
      var dlg = sec.querySelector('[data-lightbox-dialog]') || document.querySelector('[data-lightbox-dialog]');
      if (!dlg) return;
      dlg.querySelector('[data-lightbox-img]').src = trg.dataset.lightbox;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      return;
    }
    var dlgOpen = e.target.closest('[data-lightbox-dialog]');
    if (e.target.closest('[data-lightbox-close]') || (dlgOpen && e.target === dlgOpen)) {
      (dlgOpen || e.target.closest('dialog')).close();
    }
  });

  /* ---------- Announcement ---------- */
  function initAnnouncement() {
    var track = document.querySelector('[data-announcement]');
    if (!track) return;
    var items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, 4000);
  }

  document.addEventListener('click', function (e) {
    var nav = document.querySelector('[data-mobile-nav][open]');
    if (nav && !nav.contains(e.target)) nav.removeAttribute('open');
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-product-section]').forEach(function (el) { if (!el._init) { el._init = true; ProductSection(el); } });
    scope.querySelectorAll('[data-delivery]').forEach(initDelivery);
    scope.querySelectorAll('[data-ba]').forEach(initBA);
    scope.querySelectorAll('[data-reviews]').forEach(initReviews);
  }
  function boot() { init(); initAnnouncement(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
